var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"specialRulePopup"}},[_c('div',{staticClass:"specialRule-popup-bg"}),_c('div',{staticClass:"content-block"},[_c('div',{attrs:{"id":"specialRule-popup-content"}},[_c('img',{attrs:{"src":_vm.specialRuleImage}})]),_c('div',{staticClass:"closeBtn",on:{"click":_vm.closePopup}},[_vm._v("我知道了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }